import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.usuarios;

export const usuariosApiService = {
  // Obtener todos los usuarios
  async getAllUsuarios() {
    try {
      const response = await axios.get(API_BASE_URL);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      throw error;
    }
  },

  // Obtener un usuario por ID
  async getUsuarioById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuario:', error);
      throw error;
    }
  },

  // Registrar un nuevo usuario
  async registrarUsuario(sociaId, permisosIds) {
    try {
      const response = await axios.post(API_BASE_URL, {
        sociaId,
        permisosIds
      });
      return response.data;
    } catch (error) {
      console.error('Error al registrar usuario:', error);
      throw error;
    }
  },

  // Actualizar un usuario
  async actualizarUsuario(id, usuarioEstado, permisosIds) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, {
        usuarioEstado,
        permisosIds
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      throw error;
    }
  },

  // Cambiar contraseña
  async cambiarContrasenia(id, contraseniaActual, contraseniaNueva, contraseniaNuevaConfirmacion) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}/cambiar-contrasenia`, {
        contraseniaActual,
        contraseniaNueva,
        contraseniaNuevaConfirmacion
      });
      return response.data;
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      throw error;
    }
  },

  // Resetear contraseña a valor por defecto
  async resetearContrasenia(id) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}/resetear-contrasenia`);
      return response.data;
    } catch (error) {
      console.error('Error al resetear contraseña:', error);
      throw error;
    }
  },

  // Eliminar (inactivar) usuario
  async eliminarUsuario(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar usuario:', error);
      throw error;
    }
  },

  // Obtener permisos disponibles
  async getPermisosDisponibles() {
    try {
      const response = await axios.get(`${API_BASE_URL}/permisos/disponibles`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener permisos:', error);
      throw error;
    }
  }
};

export default usuariosApiService;
